import react, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";

import { useParams } from "react-router";

import { Spinner } from "../Spinner/Spinner";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import image from "../../assets/Images/success.png";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { manageSubscription } from "../../assets/Js/localStorage";
import { Congratulations } from "../Congratulations/Congratulations";

import gotoStripeDashboard from "../../assets/Js/gotoStripeDashboard";
import connectWithStripe from "../../ApiHandlers/connectWithStripe";
import { UnsccessfulAction } from "../UnsuccessfulAction/UnsuccessfulAction";

const allHandlers = {
  stripeConnectHandler: "connectWithStripe",
  stripeVerifiyHandler: "verifyStripeAccount",
};

function SuccessFail(props) {
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.userData);
  const [message, setMessage]= useState("");
  const [description, setDescription] = useState("");
  const [hasSubscription, setHasSubscription] = useState(false);
  const [hasConnectedAccount, setHasConnectedAccount] = useState(false);
  const [isAccountActive, setIsAccountActive] = useState(false);
  const [buttonTxt, setButtonTxt] = useState("");
  const [whichHandler, setWhichHandler] = useState("");
  let { id } = useParams();

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  useEffect(() => {
    if (id === "gym") {
      isUserConnected();
    }
    else if (id === "athlete") {
      var trackName = getQueryVariable("name").split("%20").join(" ");
      var welcomeNote = getQueryVariable("wnote").split("%20").join(" ");
      setMessage("You have joined"   + '\xa0' +  trackName + '\xa0' + "Track Successfully")
      if( welcomeNote ){
        setDescription(welcomeNote)
      }
      else{
        setDescription("Let's Build A Healthy Community Together")
      }
    }
  }, []);

  const isUserConnected = async () => {
    let url = `${projectSettings.baseUrl}/subscriptions/accountstatus`;
    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let data = null;
    let response = "";

    setIsLoading(true);

    response = await callAPI(url, header, type, JSON.stringify(data), token);
    if (response) {
      setIsLoading(false);
      if (response.type === "error") {
        setDescription(
          "We ran into some issues while verifying your account detials!"
        );
      } else if (response.type === "success") {
        let info = response.data.result;
        setHasSubscription(info.HasActiveSubscription);
        setHasConnectedAccount(info.HasConnectedAccount);
        setIsAccountActive(info.IsConnectedAccountActive);

        if (!info.HasConnectedAccount) {
          setButtonTxt("Connect With Stripe");
          setWhichHandler(allHandlers.stripeConnectHandler);
        } else if (info.HasConnectedAccount && !info.IsConnectedAccountActive) {
          setButtonTxt("Verify Your Account");
          setWhichHandler(allHandlers.stripeConnectHandler);
        }
        setDescription("Let's Build A Healthy Community Together");
        manageSubscription(!info.HasActiveSubscription.toString());
      }
    }
  };

  const whichClickHandler = async () => {
    if (whichHandler === allHandlers.stripeConnectHandler) {
      await connectWithStripe();
    } else if (whichHandler === allHandlers.stripeVerifiyHandler) {
      await gotoStripeDashboard();
    }
  };

  const title = useMemo(() => `Hey ${userData.FirstName}!`, [userData]);

  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center size100-92vh">
          <div className="h3">Verifying</div>
          <div className="ml-3">
            <Spinner />
          </div>
        </div>
      ) : id === "gym" ? (
        hasSubscription ? (
          <Congratulations
            title={title}
            message={message}
            description={description}
            buttonTxt={buttonTxt}
            clickHandler={whichClickHandler}
          />
        ) : (
          <UnsccessfulAction
            title={title}
            message={"You Don't Have Any Active Subscription"}
            description={description}
          />
        )
      ) : (
        <Congratulations
          title={title}
          message={message}
          description={description}
        />
      )}
    </div>
  );
}

export default SuccessFail;
